import { Hotkeys } from 'constants/Hotkeys';
import { EnumWithHotkey } from 'enums/EnumWithHotkey';

export enum SoftballPitchTypes {
  Fastball = 'Fastball',
  Dropball = 'Dropball',
  DropCurve = 'Drop-Curve',
  Riseball = 'Riseball',
  Curveball = 'Curveball',
  Changeup = 'Changeup',
  Screwball = 'Screwball',
  Offspeed = 'Offspeed',
  Other = 'Other',
  Undefined = 'Undefined',
}

export const PitchTypesHotkey: EnumWithHotkey = {
  Fastball: {
    name: 'Fastball',
    value: SoftballPitchTypes.Fastball,
    keyCode: Hotkeys.PitchType.FastBall.hotkeyCode,
    hotkeyDisplay: Hotkeys.PitchType.FastBall.hotkeyDisplay,
  },
  Dropball: {
    name: 'Dropball',
    value: SoftballPitchTypes.Dropball,
    keyCode: Hotkeys.PitchType.Dropball.hotkeyCode,
    hotkeyDisplay: Hotkeys.PitchType.Dropball.hotkeyDisplay,
  },
  DropCurve: {
    name: 'Drop-Curve',
    value: SoftballPitchTypes.DropCurve,
    keyCode: Hotkeys.PitchType.DropCurve.hotkeyCode,
    hotkeyDisplay: Hotkeys.PitchType.DropCurve.hotkeyDisplay,
  },
  Riseball: {
    name: 'Riseball',
    value: SoftballPitchTypes.Riseball,
    keyCode: Hotkeys.PitchType.Riseball.hotkeyCode,
    hotkeyDisplay: Hotkeys.PitchType.Riseball.hotkeyDisplay,
  },
  Curveball: {
    name: 'Curveball',
    value: SoftballPitchTypes.Curveball,
    keyCode: Hotkeys.PitchType.Curveball.hotkeyCode,
    hotkeyDisplay: Hotkeys.PitchType.Curveball.hotkeyDisplay,
  },
  ChangeUp: {
    name: 'ChangeUp',
    value: SoftballPitchTypes.Changeup,
    keyCode: Hotkeys.PitchType.ChangeUp.hotkeyCode,
    hotkeyDisplay: Hotkeys.PitchType.ChangeUp.hotkeyDisplay,
  },
  Screwball: {
    name: 'Screwball',
    value: SoftballPitchTypes.Screwball,
    keyCode: Hotkeys.PitchType.Screwball.hotkeyCode,
    hotkeyDisplay: Hotkeys.PitchType.Screwball.hotkeyDisplay,
  },
  Offspeed: {
    name: 'Offspeed',
    value: SoftballPitchTypes.Offspeed,
    keyCode: Hotkeys.PitchType.Offspeed.hotkeyCode,
    hotkeyDisplay: Hotkeys.PitchType.Offspeed.hotkeyDisplay,
  },
  Other: {
    name: 'Other',
    value: SoftballPitchTypes.Other,
    keyCode: Hotkeys.PitchType.Other.hotkeyCode,
    hotkeyDisplay: Hotkeys.PitchType.Other.hotkeyDisplay,
  },
  Undefined: {
    name: 'Undefined',
    value: SoftballPitchTypes.Undefined,
    keyCode: Hotkeys.PitchType.Undefined.hotkeyCode,
    hotkeyDisplay: Hotkeys.PitchType.Undefined.hotkeyDisplay,
  },
};
